import { useMutation } from "react-query";
import incidentService from "../../services/incidentService";

const useUpdateIncident = () => useMutation(incidentService.updateIncident);

export default useUpdateIncident;
